import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import ExpandableImage from '../ExpandableImage'

import { isEven } from '../../utils/num'

const BenefitsToYou = ({ upper, lower }) => (
  <section
    id="benefits-to-you"
    className="c-section c-section--forBenefits c-section--forBenefits--you"
  >
    <div className="c-section__outer container">
      <div className="c-section__tag">Benefits to you</div>
      <div className="c-section__inner">
        <div className="c-forBenefits">
          {upper.map((blurb) => (
            <div key={blurb.title} className="c-forBenefitsInfo row">
              <div className="c-forBenefitsInfo__block c-forBenefitsInfo__block--icon col-12 col-md-3">
                <img
                  className="c-forBenefitsInfo__icon img-fluid"
                  src={`/images/icons/${blurb.icon}.svg`}
                />
              </div>

              <div className="c-forBenefitsInfo__block c-forBenefitsInfo__block--text col-12 col-md-7 d-flex flex-column justify-content-center">
                <h2 className="c-forBenefitsInfo__header">{blurb.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: blurb.text }} />
              </div>
            </div>
          ))}

          <br />

          {lower.map((blurb, i) => (
            <div
              key={blurb.title}
              className={`c-forBenefitsCard ${
                !isEven(i) ? 'c-forBenefitsCard--reversed' : ''
              }`}
            >
              <div className="c-forBenefitsCard__block c-forBenefitsCard__block--text">
                <h5 className="c-forBenefitsCard__header">{blurb.title}</h5>
                <div className="c-forBenefitsCard__text">
                  <p dangerouslySetInnerHTML={{ __html: blurb.text }} />
                </div>
              </div>

              <div className="c-forBenefitsCard__block c-forBenefitsCard__block--image">
                <ExpandableImage
                  imageData={blurb.image.modal}
                  bottomRight={isEven(i)}
                >
                  <GatsbyImage
                    image={getImage(
                      blurb.image.childImageSharp.gatsbyImageData
                    )}
                    title={blurb.title}
                    alt={blurb.title}
                    className="c-forBenefitsInfo__icon img-fluid"
                  />
                </ExpandableImage>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
)

BenefitsToYou.defaultProps = {
  upper: [],
  lower: [],
}

BenefitsToYou.propTypes = {
  upper: PropTypes.array,
  lower: PropTypes.array,
}

export default BenefitsToYou

export const FragmentQuery = graphql`
  fragment BenefitsToYouFragment on MarkdownRemarkFrontmatter {
    benefitsYou {
      blurbsOne {
        title
        text
        icon
      }
      blurbsTwo {
        title
        text
        image {
          modal: childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 550
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`
